
import { AlertResponse } from '@shared/widgets/entities/alerts';

export const widgetsFeatureName = 'widgetsModule';

export interface WidgetsUIState {
  activateAlerts: boolean;
  showAlertToast: string;
  saveThisSearch: boolean;
  createAlert: boolean;
}

export type WidgetsState = Readonly<{
  alert: AlertResponse,
  ui: WidgetsUIState
}>;
